import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import { LoadingValue } from "~/modules/dashboard/components/LoadingValue.tsx";
import { useDashboardUser } from "~/modules/dashboard/hooks/useDashboardUser.tsx";
import { dayStateQueries } from "~/modules/timeTracking/api/timeTracking/timeTrackingQueries.ts";

/**
 * "Offene Tage": `untrackedDayCount` of the current month, from its own query, also when the calendar shows
 * another month. For a month with nothing left to book, it shows `0` and does not hide. A failed read hides the
 * line, and so does a count of `null`, which the current month never has.
 */
export function OpenDays() {
	const user = useDashboardUser();
	const { data, isPending, isError } = useQuery(dayStateQueries.byMonth(user?.id ?? "", format(new Date(), "yyyy-MM")));

	// No user: the query is off and stays pending, so the line does not show.
	if (!user || isError || (!isPending && data?.untrackedDayCount == null)) return null;

	return (
		<p className="h-5 text-sm text-gray-500">
			Offene Tage:{" "}
			<span className="font-semibold text-gray-900">
				{data?.untrackedDayCount ?? <LoadingValue size="line" className="min-w-4" />}
			</span>
		</p>
	);
}
